export default __webpack_public_path__ + "static/media/back.6e044690.svg";